import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../user/entities/user';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '',
})
export abstract class UserFormComponent {
    boolean = [
        { value: true, label: 'YES' },
        { value: false, label: 'NO' },
    ];

    @Input()
    user: User;
    @Input()
    loggedInUser: User;
}
